import { useCallback } from 'react';
import { useSelector } from 'react-redux';

import { getModifiedFieldDetailsPendingChangeAuthors } from 'utils/pendingChangesAuthors';

import { selectPropertyPendingChangeAuthorsByEntityKey } from 'store/loanApplications/selectors/pendingChangesAuthors.selectors';

/**
 * Returns (modifiedFieldDetails, fieldNames) => author rows for a read-only view's highlighted preview-DTO value,
 * resolved through the change-history properties the backend lists behind the field.
 * @returns {Function}
 */
const useModifiedFieldPendingChangeAuthors = () => {
  const propertyAuthorsByEntityKey = useSelector(selectPropertyPendingChangeAuthorsByEntityKey);

  return useCallback(
    (modifiedFieldDetails, fieldNames) =>
      getModifiedFieldDetailsPendingChangeAuthors(
        propertyAuthorsByEntityKey,
        modifiedFieldDetails,
        fieldNames,
      ),
    [propertyAuthorsByEntityKey],
  );
};

export default useModifiedFieldPendingChangeAuthors;
